// extracted by mini-css-extract-plugin
module.exports = {"awards-section-container":"Awards_awards-section-container__2LvV1","awards-grid-container":"Awards_awards-grid-container__2vePF"};